import { createSlice } from "@reduxjs/toolkit";
import {
  addOrRemoveAddOnFromSubscription,
  createFeaturedPart,
  createSubscription,
  fetchMembershipAddOns,
  fetchMembershipPlans,
  updateSubscription,
} from "./membershipActions";

const initialState = {
  plans: [],
  addOns: [],
  isLoading: false,
  isAddOnLoading: false,
  isPlanProcessing: false,
  isSubscriptionLoading: false,
  isFeaturedPartLoading: false,
  error: null,
};

export const membershipSlice = createSlice({
  name: "membership",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setIsPlanProcessing: (state, action) => {
      state.isPlanProcessing = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      // Fetch Membership Plans
      .addCase(fetchMembershipPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMembershipPlans.fulfilled, (state, action) => {
        state.plans = action.payload || [];
        state.isLoading = false;
        state.error = null;
      })
      .addCase(fetchMembershipPlans.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Fetch Membership AddOns
      .addCase(fetchMembershipAddOns.pending, (state) => {
        state.isAddOnLoading = true;
      })
      .addCase(fetchMembershipAddOns.fulfilled, (state, action) => {
        state.addOns = action.payload || [];
        state.isAddOnLoading = false;
        state.error = null;
      })
      .addCase(fetchMembershipAddOns.rejected, (state, action) => {
        state.isAddOnLoading = false;
        state.error = action.payload;
      })
      // Create Subscription
      .addCase(createSubscription.pending, (state) => {
        state.isSubscriptionLoading = true;
      })
      .addCase(createSubscription.fulfilled, (state, action) => {
        state.isSubscriptionLoading = false;
        state.error = null;
      })
      .addCase(createSubscription.rejected, (state, action) => {
        state.isSubscriptionLoading = false;
        state.error = action.payload;
      })
      // Update Subscription
      .addCase(updateSubscription.pending, (state) => {
        state.isSubscriptionLoading = true;
      })
      .addCase(updateSubscription.fulfilled, (state, action) => {
        state.isSubscriptionLoading = false;
        state.error = null;
      })
      .addCase(updateSubscription.rejected, (state, action) => {
        state.isSubscriptionLoading = false;
        state.error = action.payload;
      })
      // Add or remove addOn from subscription
      .addCase(addOrRemoveAddOnFromSubscription.pending, (state) => {
        state.isSubscriptionLoading = true;
      })
      .addCase(addOrRemoveAddOnFromSubscription.fulfilled, (state, action) => {
        state.isSubscriptionLoading = false;
        state.error = null;
      })
      .addCase(addOrRemoveAddOnFromSubscription.rejected, (state, action) => {
        state.isSubscriptionLoading = false;
        state.error = action.payload;
      })
      // Create Featured Part
      .addCase(createFeaturedPart.pending, (state) => {
        state.isFeaturedPartLoading = true;
      })
      .addCase(createFeaturedPart.fulfilled, (state) => {
        state.isFeaturedPartLoading = false;
        state.error = null;
      })
      .addCase(createFeaturedPart.rejected, (state, action) => {
        state.isFeaturedPartLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, setIsPlanProcessing } = membershipSlice.actions;

export default membershipSlice.reducer;
